package link.erpango.quip.data.remote.repository.catalog

import link.erpango.quip.data.remote.DResponse

interface ICatalogRepository {
    suspend fun getCatalog(updatedSince: Long? = null): DResponse<CatalogResponseDto>
}
